<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-stepper :steps="rmSteps" :current="currentStep" />
        <hm-spinner v-if="!ready" />
        <Loading :active="busy" :is-full-page="false">
          <slot>
            <hm-spinner />
          </slot>
        </Loading>
        <hm-alert />

        <b-form @submit.prevent="onSubmit" v-show="ready">
          <h4>Step 1: Review Workforce, ePHI Inventory, and Business Associates</h4>
          <hr />
          <b-form-group>
            <div slot="label">
              Spend a moment reviewing
              <b-button variant="link" class="px-0" :disabled="!ready" to="/workforce-list">workforce members</b-button>,
              <b-button variant="link" class="px-0" :disabled="!ready" to="/inventory-list">ePHI inventory</b-button> and
              <b-button variant="link" class="px-0" :disabled="!ready" to="/ba-list">business associates</b-button>, checking for accuracy of information contained within each listing. Edit as necessary and then click Next when you have completed your review.
            </div>
          </b-form-group>
          <hr />
          <b-row>
            <b-col cols="6"></b-col>
            <b-col cols="6" class="text-right">
              <b-button type="submit" variant="primary" class="px-4" :disabled="busy">Next</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { riskService } from '@/services'
import Enumerable from 'linq/linq.js'

export default {
  name: 'RiskAnalysisReview',
  data() {
    return {
      rm: {},
      ready: false,
      busy: false,
      submitted: false,
      currentStep: 1
    }
  },
  computed: {
    ...mapState(['rmSteps']),
  },
  methods: {
    ...mapActions({
      alertClear: 'alert/clear',
      alertException: 'alert/exception'
    }),
    onSubmit() {
      this.busy = true;
      this.submitted = true;
      this.alertClear();

      this.rm.reviewed = true;
      this.rm.step = this.currentStep;
      riskService.setRiskManagement(this.rm)
        .then(data => {
          this.$router.push('/risk/threats');
        })
        .catch(err => {
          this.alertException({ err, message: 'Error saving risk management.' });
        })
        .finally(() => {
          this.busy = false;
        });
    }
  },
  created() {
    this.ready = false;

    riskService.getCurrentRiskManagement()
      .then(data => {
        this.rm = data;
      }).catch((err) => {
        this.alertException({ err, message: 'Error loading risk management data.' });
      }).finally(() => {
        this.ready = true;
      });
  }
}
</script>